import { Fragment, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import { PUBLIC_USER } from 'marketplace-ui-reviews/constants/UnreviewableReason';
// @ts-expect-error untyped dependency
import { resetReviewSubmitted } from '../../actions/ReviewsActions';
// @ts-expect-error untyped dependency
import { getReviewSubmitted } from '../../selectors/reviews';
import { getIsPublicApp } from '../../selectors/app';
import { jsx as _jsx } from "react/jsx-runtime";
export default function WriteReviewButton({
  className,
  disabled = false,
  onClick,
  size = 'sm',
  unreviewableReason
}) {
  const dispatch = useDispatch();
  const reviewSubmitted = useSelector(getReviewSubmitted);
  const isPublicApp = useSelector(getIsPublicApp);
  const isReviewable = !isPublicApp && !unreviewableReason;
  useEffect(() => {
    return () => {
      dispatch(resetReviewSubmitted());
    };
  }, [dispatch]);
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(UITooltip, {
      title: reviewSubmitted ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.themes.details.reviews.unreviewable.reviewSubmitted"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `marketplace-ui-reviews.error.${isPublicApp ? `ReviewError.${PUBLIC_USER}` : unreviewableReason}`
      }),
      disabled: reviewSubmitted ? false : isReviewable,
      placement: "left",
      children: /*#__PURE__*/_jsx(UIButton, {
        className: className,
        onClick: onClick,
        use: "tertiary",
        size: size,
        disabled: reviewSubmitted || disabled || !isReviewable,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.details.reviews.write.button"
        })
      })
    })
  });
}